import React, { FC } from 'react'

interface VideoSoundOffIconProps {
  width?: number
  height?: number
  className?: string
}

const VideoSoundOffIcon: FC<VideoSoundOffIconProps> = ({
  width = 32,
  height = 32,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_96_3955)">
        {/* Background circle */}
        <rect
          width="32"
          height="32"
          rx="16"
          transform="matrix(1 0 0 -1 0 32)"
          fill="black"
          fillOpacity="0.4"
        />
        {/* Speaker with sound waves (complex path from SVG) */}
        <path
          d="M22.1113 23.083C21.7889 23.723 20.9756 24.1776 20.0215 24.1777C18.7847 24.1777 17.7812 23.4142 17.7812 22.4727C17.7816 21.8184 18.2665 21.2503 18.9775 20.9648L22.1113 23.083ZM12.2627 16.4268V20.7666H12.2383C12.249 20.8341 12.2568 20.9029 12.2568 20.9727C12.2568 21.9141 11.2542 22.6776 10.0176 22.6777C8.78077 22.6777 7.77734 21.9142 7.77734 20.9727C7.77788 20.0315 8.7811 19.2686 10.0176 19.2686C10.3954 19.2686 10.7513 19.34 11.0635 19.4658V15.6162L12.2627 16.4268ZM11.0635 10.5986C11.064 9.29815 12.2345 8.31065 13.5166 8.5293L20.5166 9.72363C21.525 9.89587 22.2622 10.77 22.2627 11.793V18.3574L21.0635 17.5469V11.793C21.063 11.3547 20.7465 10.98 20.3145 10.9062L13.3145 9.71191C12.7652 9.61831 12.2632 10.0416 12.2627 10.5986V11.5986L11.0635 10.7891V10.5986Z"
          fill="white"
        />
        {/* Cross-out line */}
        <path
          d="M6.802 10.3228L25.3086 22.8307"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_96_3955">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default VideoSoundOffIcon
